import LayerAdminService from "../../../services/LayerAdminService";
import { LayerInfo } from "../../../types/LayerAdmin/LayerInfo";
import { LayerContext } from "./LayerContext";

interface LayerProviderProps {
  layerInfo: LayerInfo;
  setLayerInfo: (layerInfo: LayerInfo) => void;
  setImportPage: (page: number) => void;
  layerAdminService: LayerAdminService;
  importsLoading: boolean;
  refreshLayerInfo: () => void;
  children: React.ReactNode;
}

const LayerProvider = ({
  setLayerInfo,
  layerInfo,
  layerAdminService,
  setImportPage,
  importsLoading,
  refreshLayerInfo,
  children,
}: LayerProviderProps) => {
  return (
    <LayerContext.Provider
      value={{
        importsLoading: importsLoading,
        layerInfo: layerInfo,
        setLayerInfo: setLayerInfo,
        layerAdminService: layerAdminService,
        setImportPage: setImportPage,
        refreshLayerInfo: refreshLayerInfo
      }}>
      {children}
    </LayerContext.Provider>
  );
};

export default LayerProvider;
